import { OptionType } from '@evinced-private/ui-common';

import {
	CRITICAL_ISSUES_METRIC_LABEL,
	SCANS_METRIC_LABEL,
	SESSIONS_METRIC_LABEL
} from 'src/apps/mfa/helpers/MfaDashboardConsts';
import { transformUsageDataResults as transformUsageDataResultsGeneric } from 'src/common/helpers/GQLRequestsHelper/QueryResultsTransformHelper';
import { SummaryItem } from 'src/common/interfaces/SummaryItem';

import { MfaUsageDataQuery } from '../MfaUsageData.generated';

export const transformMfaUsageDataResults = (
	rawResults: MfaUsageDataQuery,
	testPeriod?: OptionType
): SummaryItem[] => {
	const lastNDaysResults = rawResults?.last_n_days?.[0];
	const last2NDaysResults = rawResults?.last_2n_days?.[0];

	const lastPeriodSessionsCount = lastNDaysResults?.run_id_count ?? 0;
	const twoPeriodsSessionsCount = last2NDaysResults?.run_id_count ?? 0;

	const lastPeriodScansCount = lastNDaysResults?.total_scans_sum ?? 0;
	const twoPeriodsScansCount = last2NDaysResults?.total_scans_sum ?? 0;

	const lastPeriodCriticalIssues = lastNDaysResults?.critical_issues_sum ?? 0;
	const twoPeriodsAgoCriticalIssues = last2NDaysResults?.critical_issues_sum ?? 0;

	const criticalIssuesItem = transformUsageDataResultsGeneric(
		lastPeriodCriticalIssues,
		twoPeriodsAgoCriticalIssues,
		CRITICAL_ISSUES_METRIC_LABEL,
		testPeriod
	);

	return [
		transformUsageDataResultsGeneric(
			lastPeriodSessionsCount,
			twoPeriodsSessionsCount,
			SESSIONS_METRIC_LABEL,
			testPeriod
		),
		transformUsageDataResultsGeneric(
			lastPeriodScansCount,
			twoPeriodsScansCount,
			SCANS_METRIC_LABEL,
			testPeriod
		),
		{
			...criticalIssuesItem,
			falsePositive: true
		}
	];
};
